var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"custom-link",on:{"click":function($event){$event.preventDefault();return _vm.navigate($event)}}},[_c(_vm.wrap,{tag:"component",class:_vm.css_class,attrs:{"href":_vm.router_path}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }